import { SwitchToChromeDialog } from "@/components/Dialogs/SwitchToChromeDialog"
import { replaceDialog } from "../dialogs-state"
import { browserCapabilitiesAtom } from "../app/browser-capabilities"
import { store } from "../store"

export const shouldBlockProjectCreationForSampleOnly = () => {
	const capabilities = store.get(browserCapabilitiesAtom)
	return capabilities.supportsSampleOnly
}

export const ensureProjectCreationAllowed = () => {
	if (!shouldBlockProjectCreationForSampleOnly()) {
		return true
	}

	replaceDialog(SwitchToChromeDialog)
	return false
}
